import VH from './utils/vh';

document.addEventListener('DOMContentLoaded', () => {
  const vh = new VH();
});
